/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import classnames from 'classnames';
import * as _ from 'underscore';

class SelectedFeedItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            iconImageValid: true
        };

        this.onImgError = this.onImgError.bind(this);
    }

    onImgError(e) {
        this.setState({
            iconImageValid: false
        });
    }

    render() {
        let icon = null,
            title = null,
            link = null,
            description = null,
            constants = this.props.app.config.constants,
            editButton = null,
            itemClass = classnames('feed-list-item', {
                'error': (this.props.searchErrors !== null) ? true : false,
                'validating': this.props.isValidating
            }),
            error = null,
            iconImageUrl = this.props.feed.visualUrl;

        if (iconImageUrl && iconImageUrl.match('http://')) {
            iconImageUrl = iconImageUrl.replace('http://', 'https://');
        }

        if (this.props.feed.type == constants.INPUT_TYPE_FEED) {
            if (this.props.feed.subtype && this.props.feed.subtype == constants.INPUT_SUBTYPE_PINTEREST) {
                icon = (<IconFactory.pinterest bare={true} large={true}/>);
                title = this.props.feed.name;
            } else {
                if (this.props.feed.visualUrl && this.state.iconImageValid) {
                    icon = (<img src={iconImageUrl} className="inline-icon-img" onError={this.onImgError}/>);
                } else {
                    icon = (<i className="icon ion-social-rss feed-placeholder"></i>);
                }
                title = this.props.feed.title;
                description = this.props.feed.description;
            }
            link = (<a href={"/feedPreview.php?url=" + encodeURIComponent(this.props.feed.url)} className="feed-search-preview" target="_blank">view feed</a>);
        } else if (this.props.feed.type == constants.INPUT_TYPE_TWITTER) {
            icon = (<IconFactory.twitter bare={true} large={true}/>);
            title = this.props.feed.name;
        } else if (this.props.feed.type == constants.INPUT_TYPE_INSTAGRAM) {
            icon = (<IconFactory.instagram bare={true} large={true}/>);
            title = this.props.feed.name;
        } else if (this.props.feed.type == constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
            icon = (<IconFactory.instagrambusiness bare={true} mono={true} large={true}/>);
            title = this.props.feed.name;
        } else if (this.props.feed.type == constants.INPUT_TYPE_FACEBOOK_PAGE) {
            icon = (<IconFactory.facebook bare={true} large={true}/>);
            title = this.props.feed.name;
        }

        if (this.props.searchErrors !== null) {
            const extractString = (error) => {
                if (_.isString(error)) {
                    return error;
                }
                for (let key in error) {
                    return extractString(error[key]);
                }
            };

            error = (
                <div className="feed-list-item-error">
                    We can't validate your feed: {extractString(this.props.searchErrors.errors.validation)}
                </div>
            );
        } else if (this.props.isValidating) {
            error = (
                <div className="source-validation">
                    Validating feed...
                </div>
            );
        }

        if (parseInt(this.props.app.flags.routeViewType, 10) === constants.ROUTE_VIEW_ADVANCED && this.props.isCurated === false) {
            editButton = (
                <div className="feed-list-item-edit" onClick={this.props.onAdvancedFeedConfigure} data-feedid={this.props.feed.id} role="button" aria-label="configure input">
                    <i className="fa fa-border fa-cog"></i>
                </div>
            );
        }
        return(
            <li className={itemClass}>
                <div className="source-icon">
                    <div className="inline-icon">
                        {icon}
                    </div>
                </div>
                <div className="source-info">
                    <div className="source-title">{title}</div>
                    <div className="source-desc">{description}</div>
                    <div className="source-preview">{link}</div>
                    {error}
                </div>
                <div className="source-controls">
                    {editButton}
                    <div className="feed-list-item-remove" onClick={this.props.removeFeed} data-feedid={this.props.feed.id} role="button" aria-label="remove feed">
                        <i className="fa fa-border fa-times"></i>
                    </div>
                </div>
            </li>
        );
    }

};

SelectedFeedItem.propTypes = {
    feed: PropTypes.object,
    onAdvancedFeedConfigure: PropTypes.func,
    removeFeed: PropTypes.func,
    isCurated: PropTypes.bool,
    isValidating: PropTypes.bool,
    searchError: PropTypes.object
};

SelectedFeedItem.defaultProps = {
    feed: null,
    onAdvancedFeedConfigure: () => {},
    removeFeed: () => {},
    isCurated: false,
    isValidating: false,
    searchError: null
};

export default SelectedFeedItem;
